/*
 * @TODO CB-20310
 * Message of the Day
 */

/* istanbul ignore next */
const styles = ({ palette = {}, spacing = {}, typography = {} }) => ({
  borderRadius: 16,
  width: spacing.unit * 4.5,
  height: spacing.unit * 3,
  backgroundColor: palette.text.light,
  border: `1px solid ${palette.error.lightOrange}`,
  color: palette.error.lightOrange,
  fontSize: typography.fontSize
});

export default styles;
